export default {
    logisticsServe: {
        Description: {
            title: 'Logistics Services',
            module1: {
                title: 'Domestic Logistics Services',
                text: 'Powered by smart technology, we integrate extensive domestic transportation resources with a comprehensive road network and flexible vehicle options. Tailored for SMEs, we deliver intelligent logistics solutions covering pickup, route optimization, and precise delivery - ensuring seamless nationwide cargo movement.',
                btn: 'Enter Logistics Platform',
                box1: {
                    title: 'Global Capacity',
                    text: 'Our multimodal transport system transcends geographical barriers, connecting numerous countries worldwide to drive global economic growth.'
                },
                box2: {
                    title: 'End-to-End Supply Chain Solutions',
                    text: 'Leveraging our global network, we optimize procurement, warehousing, and distribution with real-time digital monitoring for efficient, stable, and transparent supply chain operations.'
                },
                box3: {
                    title: 'Multimodal Transport',
                    text: 'Integrated sea-land-air solutions: ocean shipping for bulk cargo, flexible land distribution, and rapid air delivery - combining advantages for diverse logistics needs.'
                },
                box4: {
                    title: 'Production-to-Market Connectivity',
                    text: 'Covering 90%+ agricultural production regions with direct access to 80%+ Chinese cities - from local deliveries to cross-country shipments.'
                },
                box5: {
                    title: 'Certified Driver Network',
                    text: 'Thousands of verified professional drivers ensuring reliable, efficient transportation for premium agricultural products nationwide.'
                },
                box6: {
                    title: '10,000+ Active Vehicles',
                    text: 'Comprehensive fleet including flatbeds, box trucks, and trailers (from vans to 17.5m trucks) meeting all cargo requirements.'
                },
            },
            module2: {
                title: 'Cross-border Logistics',
                text: 'Our digital-core solutions provide global transportation resources, smart logistics products, and comprehensive support services - empowering B2B SMEs in international trade.',
            },
        },
    }
}